import { LogisticsProvider, Manufacturer, ManufacturerParcelType, FaultCode } from "./models";
import { BaseDatabase, DexieTable } from "../../core/db/index";
import Order from "./models/order";
import { ForeignKey } from "../../core/db/models";
import { OrderItemLike } from "./models/orderItem";
import { OrderAssignmentLike } from "./models/orderAssignment";
import { OrderItemAssignmentLike } from "./models/orderItemAssignment";

export default class ValtasiirtoDatabase extends BaseDatabase
{
    public Order: Dexie.Table<Order, number>;
    public OrderItem: Dexie.Table<OrderItemLike, number>;
    public LogisticsProvider: Dexie.Table<LogisticsProvider, number>;
    public Manufacturer: Dexie.Table<Manufacturer, number>;
    public ManufacturerParcelType: Dexie.Table<ManufacturerParcelType, number>;
    public OrderAssignment: Dexie.Table<OrderAssignmentLike, number>;
    public OrderItemAssignment: Dexie.Table<OrderItemAssignmentLike, number>;
    public FaultCode: Dexie.Table<FaultCode, number>;

    constructor(name: string)
    {
        super(name);

        this.version(2).stores({
            Order: 'id,ext_id,state,logistics_provider_id',
            OrderItem: 'id,ext_id,order_id,manufacturer_id,parcel_type_id',
            OrderAssignment: 'id,order_id,user_id,fault_code_id',
            OrderItemAssignment: 'id,order_item_id,user_id',
            LogisticsProvider: 'id,ext_id',
            Manufacturer: 'id,ext_id',
            ManufacturerParcelType: 'id,ext_id,manufacturer_id',
            FaultCode: 'id,ext_id',
        });

        this.Order.mapToClass(Order);
    }
}